export default function DotLoader() {
  return (
    <div className="flex items-center text-primary justify-center min-h-72">
      <img src="/dots.svg" width={60} />
    </div>
  );
}
